import React from "react";
import comingsoon from "../../assets/images/comingsoon.png"
import screenGame from "../../assets/images/screenGame.png"
import styles from "./shopping.module.css"
const Shopping = () => {
    return (
        <div className={styles.shoppingContainer}>
            {/* <div className={styles.bagContainer}>
                <img src={bag} className={styles.bag} alt="bag" />
                <button className={styles.bagButton}>ورود به فروشگاه</button>
            </div> */}
            <div className={styles.screenContainer}>
                <img className={styles.screenGame} src={screenGame} alt="screenGame"/>
            </div>
            <div className={styles.comingSoonContainer}>
                <img className={styles.comingsoonImg} src={comingsoon} alt="comingsoon"/>
            </div>
        </div>

    )
}
export default Shopping; 
